import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { PriceContainer } from '../../containers/filters/PriceContainer';

export const price: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: PriceContainer,
};
